import { render } from "./MockupView.vue?vue&type=template&id=0f4cde69&scoped=true"
import script from "./MockupView.vue?vue&type=script&lang=js"
export * from "./MockupView.vue?vue&type=script&lang=js"

import "./MockupView.vue?vue&type=style&index=0&id=0f4cde69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4cde69"]])

export default __exports__